import { cn } from '@/lib/utils';

import type { PolymorphicComponentProps } from './types';

type GridProps<E extends React.ElementType = 'div'> =
    PolymorphicComponentProps<E>;

/**
 * Grid - CSS Grid container
 * For 2D layouts
 *
 * @example
 * <Grid className="grid-cols-3 gap-4 p-6">
 *   {children}
 * </Grid>
 */
export const Grid = <E extends React.ElementType = 'div'>({
    as,
    className,
    children,
    ...props
}: GridProps<E>) => {
    const Component = as || 'div';
    return (
        <Component className={cn('grid', className)} {...props}>
            {children}
        </Component>
    );
};
